<template>
  <div class="CustomerService">
    <a :href="`${href}&clientId=${name}`">
      <img src="/static/img/kf.png" alt="" />
    </a>
  </div>
</template>

<script>
export default {
  name: "CustomerService",
  components: {},
  data() {
    return {
      href: `https://other.youxuanmall.net/wapchat.html?accessId=69fc7120-36f2-11ec-970e-ab3ba8e9c772&fromUrl=https://www.youxuanmall.net&urlTitle=积分云&language=ZHCN&otherParams={%22peerId%22:%2210053430%22}`
    };
  },
  computed: {
    name() {
      return this.$store.state.userinfo.user_name
    }
  }
};
</script>

<style lang="less">
.CustomerService {
  position: fixed;
  bottom: 17%;
  right: 20px;
  z-index: 9999;

  img {
    width: 50px;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/CustomerService.vue